import validateNumber from './validate-number';
export default validateNumber(16);
